import {Box, Stack, Switch, Typography} from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import {useEffect, useState} from "react";
import NotificationsIcon from '@mui/icons-material/Notifications';
import WebAssetIcon from '@mui/icons-material/WebAsset';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import {useDarkMode} from "../../darkMode/hook/useDarkMode";

const NotificationConfigItem = (props) => {

    const [push, setPush] = useState(props.push)
    const [email, setEmail] = useState(props.email)
    const [notificationActivated, setNotificationActivated] = useState(props.push || props.email)

    const pushOnly = push && !email;
    const emailOnly = !push && email;
    const both = push && email;
    const {mode} = useDarkMode();

    const styles = {
        backgroundColor: "unset",
        borderWidth: 0,
        "&::before": {
            display: "none"
        },
        "&:hover:not(.Mui-expanded)": {
            backgroundColor: mode.settings.notifCardBackgroundCor,
        },
        borderRadius: 3,
        "&:first-of-type": {
            borderRadius: 3
        },
        "&:last-of-type": {
            borderRadius: 3
        },
        "&:has(.Mui-expanded)": {
            boxShadow: "0px 0px 4px 0px #00000066"
        },
        transition: "background 700ms"
    }

    useEffect( () =>  setNotificationActivated(email || push), [email, push] )

    useEffect(() => props.onChange && props.onChange( { email: email, push: push, id: props.id } ) , [email, push])

    return <Accordion
        sx={styles}
        variant="outlined"
        expanded={props.id === props.openedId}
        onChange={ props.handleOpened && props.handleOpened(props.id) }
    >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls={`notification-${props.id}`}
          id={`notification-${props.id}`}
        >
            <Stack>
              <Typography variant="subtitle1" color={mode.settings.textColor3}>{props.title}</Typography>
                <Typography m={0} color={mode.settings.textColor3}>
                    { both ? "Push, mail":"" }
                    { emailOnly ? "Mail seulement": "" }
                    { pushOnly ? "Push seulement":"" }
                    { !push && !email ? "Désactivé":"" }
                </Typography>
            </Stack>
        </AccordionSummary>
        <AccordionDetails>
            <Box style={{backgroundColor : mode.settings.cardBackgroundColor}}>
                <Typography color={mode.settings.textColor3}>
                    {props.description}
                </Typography>
                <Stack mt={2} pl={2} >
                    <Stack direction="row" gap={2} >
                        <NotificationsIcon  style={{color : mode.settings.textColor3}}/>
                        <Box flexGrow={1} >
                            <Typography color={mode.settings.textColor3}>
                                Autoriser les notifications
                            </Typography>
                        </Box>
                        <Switch checked={notificationActivated} onChange={ e => {
                            setNotificationActivated(e.target.checked)
                            setEmail(e.target.checked)
                            setPush(e.target.checked)
                        }} />
                    </Stack>
                    <Stack direction="row" gap={2} >
                        <WebAssetIcon style={{color : mode.settings.textColor3}}/>
                        <Box flexGrow={1} >
                            <Typography color={mode.settings.textColor3}>
                                Recevoir mes notifications par push
                            </Typography>
                        </Box>
                        <Switch checked={push} onChange={e => setPush(e.target.checked)} />
                    </Stack>
                    <Stack direction="row" gap={2} >
                        <MailOutlineIcon style={{color : mode.settings.textColor3}}/>
                        <Box flexGrow={1} >
                            <Typography color={mode.settings.textColor3}>
                                Recevoir mes notifications par e-mail
                            </Typography>
                        </Box>
                        <Switch checked={email} onChange={e => setEmail(e.target.checked)} />
                    </Stack>
                </Stack>
            </Box>
        </AccordionDetails>
    </Accordion>
}



export default NotificationConfigItem
